import { Sheet, SheetContent, SheetTitle, SheetDescription } from "@/components/ui/sheet";
import { Minus, Plus, X } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { useCheckout } from "@/hooks/useCheckout";
import { money } from "@/lib/api";

const Line = ({ item }) => {
  const { setQty } = useCart();
  return (
    <li className="flex gap-4 py-5 border-b border-purple-400/15" data-testid={`cart-item-${item.id}`}>
      <img src={item.image} alt="" className="w-20 h-24 object-cover rounded-xl" />
      <div className="flex-1 min-w-0">
        <div className="flex justify-between gap-2">
          <p className="font-display text-xl leading-tight">{item.name}</p>
          <button data-testid={`cart-item-remove-${item.id}`} onClick={() => setQty(item.id, 0)} aria-label="Remove" className="text-purple-300 hover:text-white"><X className="w-4 h-4" /></button>
        </div>
        <p className="font-mono text-sm text-amber-200 mt-1">{money(item.price)}</p>
        <div className="mt-3 inline-flex items-center rounded-full border border-purple-300/30">
          <button data-testid="cart-item-quantity-decrease" onClick={() => setQty(item.id, item.quantity - 1)} className="p-2" aria-label="Less"><Minus className="w-3.5 h-3.5" /></button>
          <span className="w-7 text-center font-mono text-sm" data-testid={`cart-item-qty-${item.id}`}>{item.quantity}</span>
          <button data-testid="cart-item-quantity-increase" onClick={() => setQty(item.id, item.quantity + 1)} className="p-2" aria-label="More"><Plus className="w-3.5 h-3.5" /></button>
        </div>
      </div>
    </li>
  );
};

export const CartDrawer = () => {
  const { items, total, open, setOpen } = useCart();
  const { checkout, busy } = useCheckout();

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetContent data-testid="cart-drawer" className="bg-[#170a24] border-purple-400/20 w-full sm:max-w-md flex flex-col p-6">
        <SheetTitle className="font-display font-normal text-4xl">Your cart</SheetTitle>
        <SheetDescription className="text-purple-200">Bracelets waiting for a wrist.</SheetDescription>
        {items.length === 0 ? (
          <div className="flex-1 grid place-items-center text-center text-purple-200" data-testid="cart-empty">
            <p className="font-display italic text-2xl">Nothing here yet…<br />the moon is patient.</p>
          </div>
        ) : (
          <>
            <ul className="flex-1 overflow-y-auto mt-4" data-lenis-prevent>
              {items.map((i) => <Line key={i.id} item={i} />)}
            </ul>
            <div className="pt-5 space-y-4">
              <div className="flex justify-between items-baseline">
                <span className="text-purple-200">Subtotal</span>
                <span className="font-mono text-2xl text-amber-200" data-testid="cart-total">{money(total)}</span>
              </div>
              <p className="text-xs text-purple-200/80">Shipping and tax calculated at secure checkout.</p>
              <button data-testid="checkout-stripe-btn" disabled={busy}
                onClick={() => checkout(items.map((i) => ({ product_id: i.id, quantity: i.quantity })))}
                className="w-full rounded-full bg-purple-200 text-[#0e0616] py-4 font-medium hover:bg-amber-200 transition-colors disabled:opacity-60">
                {busy ? "Opening checkout…" : "Checkout securely"}
              </button>
            </div>
          </>
        )}
      </SheetContent>
    </Sheet>
  );
};
